/**
 * Affichage fr-FR d'une date "calendrier" sans décalage fuseau (évite le jour -1
 * causé par new Date('YYYY-MM-DD') interprété en UTC).
 */
export function formatDateOnlyFr(dateInput) {
  if (dateInput == null || dateInput === '') return '-';
  const s = String(dateInput).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (m) {
    const y = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    const d = parseInt(m[3], 10);
    return new Date(y, mo, d).toLocaleDateString('fr-FR');
  }
  const dt = new Date(s);
  return Number.isNaN(dt.getTime()) ? '-' : dt.toLocaleDateString('fr-FR');
}

/**
 * Valeur pour input type="date" (YYYY-MM-DD) depuis l'API, sans conversion fuseau.
 */
export function toDateInputValue(dateInput) {
  if (dateInput == null || dateInput === '') return '';
  const s = String(dateInput).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  return m ? `${m[1]}-${m[2]}-${m[3]}` : '';
}
